<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        vehicleTypeOptions: [],
        form: [
          { // 录入时间
            label: '录入时间',
            value: 'createDate',
            type: 'date',
            placeholder: '请输入录入时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 车牌号
            label: '车牌号',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号',
          },
          { // 牌照类型
            label: '牌照类型',
            value: 'vehicleType',
            type: 'select',
            placeholder: '请选择牌照类型',
          },
          { // 事故时间
            label: '事故时间',
            value: 'accidentDate',
            type: 'date',
            placeholder: '请输入事故时间',
            attr: {
              type: 'daterange',
            },
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 录入时间
      if (searchBoxData.createDate && searchBoxData.createDate.length > 0) {
        searchBoxData.createStartDate = this.formatDate(searchBoxData.createDate[0]);
        searchBoxData.createEndDate = this.formatDate(searchBoxData.createDate[1]);
        delete searchBoxData.createDate;
      }
      // 事故时间
      if (searchBoxData.accidentDate && searchBoxData.accidentDate.length > 0) {
        searchBoxData.accidentStartDate = this.formatDate(searchBoxData.accidentDate[0]);
        searchBoxData.accidentEndDate = this.formatDate(searchBoxData.accidentDate[1]);
        delete searchBoxData.accidentDate;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'ALL_LICENCE_TYPE',
    });
    this.searchBoxData.vehicleTypeOptions = enumsList[0];
  },
};
</script>

<style lang="scss" scoped>
</style>
